var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1023 16.1023C18.8826 16.3219 18.8826 16.6781 19.1023 16.8977C19.3219 17.1174 19.6781 17.1174 19.8977 16.8977L20.8674 15.9281C21.38 15.4155 21.38 14.5845 20.8674 14.0719L19.8977 13.1023C19.6781 12.8826 19.3219 12.8826 19.1023 13.1023C18.8826 13.3219 18.8826 13.6781 19.1023 13.8977L19.642 14.4375L15.75 14.4375C15.4393 14.4375 15.1875 14.6893 15.1875 15C15.1875 15.3107 15.4393 15.5625 15.75 15.5625L19.642 15.5625L19.1023 16.1023Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 9.38672L16.5 9.38672C17.6391 9.38672 18.5625 10.3101 18.5625 11.4492C18.5625 11.7599 18.3107 12.0117 18 12.0117C17.6893 12.0117 17.4375 11.7599 17.4375 11.4492C17.4375 10.9315 17.0178 10.5117 16.5 10.5117H14.25V9.38672ZM18 18.3867C18.3107 18.3867 18.5625 18.6386 18.5625 18.9492C18.5625 20.0883 17.6391 21.0117 16.5 21.0117H14.25L14.25 19.8867H16.5C17.0178 19.8867 17.4375 19.467 17.4375 18.9492C17.4375 18.6386 17.6893 18.3867 18 18.3867Z",
    fill: "#DE8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.25 10.4976C8.25 9.95633 8.53646 9.4509 9.01337 9.15068L11.5848 7.77459C12.7241 7.05742 14.25 7.82859 14.25 9.12149L14.25 20.8785C14.25 22.1714 12.7241 22.9426 11.5848 22.2254L9.01338 20.8469C8.53647 20.5467 8.25001 20.0412 8.25001 19.5L8.25 10.4976Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogout);
export default __webpack_public_path__ + "static/media/menu_logout.953a5b3ea776c056bb9c3df25b5c7420.svg";
export { ForwardRef as ReactComponent };